@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  overflow: auto;
  grid-template-areas:
    "radio-group revision-number"
    "footer footer";
  grid-template-columns: max-content minmax(200px, 1fr);
  grid-template-rows: max-content max-content;
}

.main {
  display: contents;
}

.radio-group {
  grid-area: radio-group;
}
.revision-number {
  grid-area: revision-number;
}
.footer {
  grid-area: footer;
}
